'use strict';
import {Observable} from 'rxjs/Observable';
import {LOADED, NO_DATA} from '../loading-icon/loading-states';

const filterTemplate = require('./filters/projects-filter.html');

module.exports = [
  '$exceptionHandler',
  '$filter',
  'BaseFilterMixin',
  ProjectsFilterMixin];

function ProjectsFilterMixin(
  $exceptionHandler,
  $filter,
  BaseFilterMixin,
) {
  return function ProjectsFilter(vm, $scope, currentFilter) {
    const baseFilter = new BaseFilterMixin($scope, {
      controllerAs: 'selector',
      filterTemplate: filterTemplate,
      initialFilter: currentFilter,
      defaultSortProperty: 'name',
      filterOptions: {
        status: {
          cancelled: true,
          has_rejections: true,
          pending: true,
          in_progress: true,
          complete: true
        }
      }
    });

    return {
      initFiltering: initFiltering,
      destroyFiltering: baseFilter.destroyFiltering.bind(baseFilter)
    };

    function initFiltering(publicList$, privateList$) {
      baseFilter.registerFilter('filteredList');

      const nameFilter = $filter.$filterByProperty('name');
      const list$ = Observable.combineLatest(
        publicList$,
        privateList$,
        baseFilter.filterOptionsObservable,
        baseFilter.sortOptionsObservable,
        baseFilter.filterObservable,
        (list, privateList, filterOptions, sortOptions, autoFilter) => {
          const combined = $filter.$combineLists(list, privateList);
          const filtered = applyFilterOptions(combined, filterOptions);
          const sorted = applySortOptions(filtered, sortOptions);
          return nameFilter(sorted, autoFilter);
        });

      baseFilter.activeSubscriptions.push(
        Observable.combineLatest(
          publicList$,
          privateList$,
          (publicList, privateList) => getSize(publicList) + getSize(privateList)
        )
          .subscribe((size) => {
            $scope.$evalAsync(() => {
              vm.loadingMode = size > 0 ? LOADED : NO_DATA;
            });
          })
      );

      baseFilter.activeSubscriptions.push(
        list$.subscribe(function (results) {
          $scope.$safeApply($filter.$replaceArrayContents.bind($filter, vm.filteredList, results));
        }, function delegateError(error) {
          $exceptionHandler(error, 'ProjectsFilterMixin.toString: error occurred while updating list contents');
        }));

      function applyFilterOptions(list, options) {
        let project;
        const result = [];

        try {
          for (let i = 0, length = list.length; i < length; i++) {
            project = list[i];

            //if (project && project.isDeleting) continue;
            if (filterOnStatus(project, options)) continue;

            result.push(project);
          }
        } catch (error) {
          //TODO: do something with this?
          //console.log('error with filterAssetsOptions', list, options, error);
        }

        return result;
      }

      function filterOnStatus(project, options) {
        //Assignment filters
        // TODO: convert to accept a task or date instead?
        const status = project ? project.status : null;

        if (!status) return false;

        if (status && !options.status[status]) return true;

        return false;
      }

      function applySortOptions(list, sortOptions) {
        return list.sort($filter.$sortByProperty('name', sortOptions.currentMethod, true));
      }
    }
  };

  function getSize(list) {
    return list ? list.$size() : 0;
  }
}



// WEBPACK FOOTER //
// ./src/js/core-components/selectors/ProjectsFilterMixin.js